import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';

// كائن الإعدادات الذي نسخته من فايربيس
const firebaseConfig = {
    apiKey: "AIzaSyAR00_AS7HXvYpAie_9Jpay-7AK08gBNvM",
    authDomain: "group-linktree.firebaseapp.com",
    projectId: "group-linktree",
    storageBucket: "group-linktree.firebasestorage.app",
    messagingSenderId: "589409668319",
    appId: "1:589409668319:web:b2dfc44a7f7870a9e16d6a"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);